export default {
  delayedPercentage(state, getters) {
    const { delayed = 0 } = state.openShipmentOrders;

    return getters.calculateDelayedPercentage(delayed);
  },

  shipmentOrdersArray(state) {
    const { status_array = {} } = state.shipmentOrderStatus;

    return status_array;
  },
  shipmentOrdersTotal(state) {
    const { total_amount = 0 } = state.shipmentOrderStatus;

    return total_amount;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-order-status/store/getters.js